<template>
  <el-carousel
      :height="isMobile ? '250px' : '400px'"
      :autoplay="true"
      :interval="3000"
  >
    <el-carousel-item>
      <div class="banner-item" :style="{ backgroundColor: '#0a0f15'}">
        <div class="container">
          <div class="banner-content">
            <img
                src="@/assets/images/车载测试工程师培养计划.png"
                alt="就业成功案例图示"
                class="rocket-img"
            />
            <div class="banner-text">
              <h3 class="main-title">车载测试零基础保就业课程</h3>
              <p class="sub-title">15章节 · 281课时 · 6+岗位方向</p>
              <p class="desc">覆盖智能座舱、智能驾驶、车载网络、车联网全栈测试技术</p>
              <el-button
                  class="banner-btn"
                  type="primary"
                  size="large"
                  @click="$router.push('/courses')"

              >
                了解课程
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-carousel-item>
    <el-carousel-item>
      <div class="banner-item" :style="{ backgroundColor: '#3d627f' }">
        <div class="container">
          <div class="banner-content">
            <img
                src="@/assets/images/高薪就业保障.png"
                alt="就业保障"
                class="rocket-img"
            />
            <div class="banner-text">
              <h3 class="main-title">高薪就业保障</h3>
              <p class="sub-title">平均起薪¥12,800 · 就业率96.8%</p>
              <p class="desc">签订就业保障协议，未达保障薪资退还学费</p>
              <el-button
                  class="banner-btn"
                  type="primary"
                  size="large"
                  @click="scrollToEmploymentData"
              >
                就业数据
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-carousel-item>
  </el-carousel>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue'

// 原有响应式状态和屏幕检查逻辑不变
const isMobile = ref(false)
const checkScreenSize = () => {
  isMobile.value = window.innerWidth < 768
}

onMounted(() => {
  checkScreenSize(); window.addEventListener('resize', checkScreenSize)
})

// 新增：滚动到就业数据组件的方法
const scrollToEmploymentData = () => {
  // 1. 获取主页面中就业数据组件的锚点元素
  const targetElement = document.getElementById('employmentDataSection')

  if (targetElement) {
    // 2. 平滑滚动到目标元素（behavior: 'smooth' 实现平滑效果）
    targetElement.scrollIntoView({
      behavior: 'smooth',  // 平滑滚动（移除则为瞬间跳转）
      block: 'start'       // 滚动后目标元素顶部对齐视口顶部
    })
  } else {
    console.warn('未找到就业数据组件的锚点元素，请检查ID是否正确')
  }
}
</script>

<style scoped>
.banner-item {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container {
  width: 100%;
  max-width: 1200px;
  padding: 0 20px;
}

.banner-content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: #fff;
}

.rocket-img {
  width: 360px;
  height: auto;
  margin-right: 40px;
  transition: all 0.3s ease;
}

.main-title {
  font-size: 32px;
  margin-bottom: 10px;
}

.sub-title {
  font-size: 24px;
  font-weight: bold;
  margin: 10px 0;
}

.desc {
  font-size: 16px;
  margin-bottom: 20px;
}

.banner-btn {
  background-color: #fff;
  color: #ff6700;
  border: none;
  margin-top: 10px;
}

.banner-btn:hover {
  background-color: #f5f5f5;
  color: #e55a00;
}

/* 响应式样式 */
@media (max-width: 768px) {
  .banner-content {
    flex-direction: column;
    text-align: center;
  }

  .banner-btn {
    width: 80px;
    height: 30px;
    border: none;
    margin-top: 4px;
  }

  .rocket-img {
    width: 80px;
    margin-right: 0;
  }

  .main-title {
    font-size: 20px;
  }

  .sub-title {
    font-size: 16px;
  }

  .desc {
    font-size: 10px;
  }
}
</style>
